import type {
    MilestoneCategory,
    MilkType,
    NappyType,
    ReminderKind,
    SleepKind,
} from '@baby-tracker/validation';
import { format, parseISO } from 'date-fns';

/**
 * Human labels for stored enum values. The API keeps the canonical vocabulary; the UI shows
 * these. Exports keep the raw values.
 */

export const sleepKindLabels: Record<SleepKind, string> = {
    nap: 'Nap',
    night: 'Night sleep',
    unspecified: 'Sleep',
};

export const nappyTypeLabels: Record<NappyType, string> = {
    wet: 'Wet',
    dirty: 'Dirty',
    mixed: 'Mixed',
    dry: 'Dry',
};

export const milkTypeLabels: Record<MilkType, string> = {
    breast_milk: 'Breast milk',
    formula: 'Formula',
    mixed: 'Mixed',
    other: 'Other',
};

export const reminderKindLabels: Record<ReminderKind, string> = {
    feed: 'Feed',
    pump: 'Pump',
    medication: 'Medication',
    sleep: 'Sleep',
    custom: 'Reminder',
};

export const milestoneCategoryLabels: Record<MilestoneCategory, string> = {
    motor: 'Motor',
    language: 'Language',
    social: 'Social',
    cognitive: 'Thinking',
    first: 'First',
    other: 'Other',
};

/** Capitalises a stored value that has no dedicated label map, e.g. `seedy` → `Seedy`. */
export function titleCase(value: string): string {
    return value
        .split('_')
        .map((part) => {
            const first = part[0];
            return first === undefined ? part : first.toUpperCase() + part.slice(1);
        })
        .join(' ');
}

/** `2026-10-13` → `Tue 13 Oct 2026`. Calendar dates have no zone, so no conversion applies. */
export function formatCalendarDate(date: string): string {
    return format(parseISO(date), 'EEE d MMM yyyy');
}

/** `2026-10-13` → `13 Oct`, for compact lists. */
export function formatShortDate(date: string): string {
    return format(parseISO(date), 'd MMM');
}
